<template>
  <div class="chat">
    <div>
      <div class="card">
        <div class="card-header">
          チャット
        </div>
        <!-- <ul class="list-group list-group-flush">
          <li class="list-group-item" v-for="comment in comments" :key="comment.id">{{ comment.username + ': ' + comment.content }}</li>

        </ul> -->
        <div class="overflow-auto chat-display" style="max-height: 50vh">
          <infinite-loading @infinite="next" direction="top">
            <div slot="spinner"></div>
            <span slot="no-more"></span>
            <span slot="no-results"></span>
          </infinite-loading>
          <ul>
            <li class="list-group-item" v-for="comment in comments" :key="comment.id">{{ comment.username + ': ' + comment.content }}</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="action">
      <div class="form-group">
        <input class="form-control" type="text" placeholder="発言を入力してください。" v-model="comment" @change="createComment">
      </div>
    </div>
  </div>
</template>
<script>
import firebase from 'firebase'
import InfiniteLoading from 'vue-infinite-loading';

export default {

  name: 'Chat',
  props: {
    room_id: { type: String, required: true }
  },
  components: {InfiniteLoading},
  data() {
    return {
      db: null,
      query: null,
      comment: null,
      comments: [],
      topDate: null,
      isEnd: false
    }
  },
  methods: {
    scrollBottom(){
      this.$nextTick(() => {
        let scroll = document.getElementsByClassName('chat-display')[0];
        scroll.scrollTop = scroll.scrollHeight;
      })
    },
    createComment() {
      if (this.comment === null){
        return;
      }

      this.db.collection('rooms').doc(this.room_id).collection('comments').add({content: this.comment, uid: this.user.uid, username: this.user.displayName, created: firebase.firestore.FieldValue.serverTimestamp()});
      this.comment = null;

      this.scrollBottom();
    },
    async loadComments(topDate=null, limit=10) {
      let query = this.query.orderBy('created', 'desc');
      if (topDate != null) {
        query = query.startAfter(topDate.toDate());
      }

      return await query.limit(limit).get().then((es)=>{
        let count = 0;

        es.forEach((doc) => {
          this.comments.unshift({content: doc.data().content, id: doc.id, uid: doc.data().uid, username: doc.data().username, date: doc.data().created});
          count++;
        });

        this.topDate = this.comments[0].date;

        this.isEnd = count < limit;
        return;
      });
    },
    next($state) {
      setTimeout(() => {
        this.loadComments(this.topDate, 20);

        if (this.isEnd){
          $state.complete();
        }else{
          $state.loaded();
        }
      }, 300);
    }

  },
  // firestore() {
  //   return {
  //     comments: this.db.collection('rooms').doc(this.room_id).collection('comments')
  //   }
  // },
  created(){
    this.db = firebase.firestore();
    this.query = this.db.collection('rooms').doc(this.room_id).collection('comments');
    this.scrollBottom();
    const vue = this;

    firebase.auth().onAuthStateChanged(user => {
      this.user = user ? user : {}
      if (user) {
        vue.query.orderBy('created').limitToLast(3).onSnapshot((qs)=>{
          qs.docChanges().forEach((change)=>{
            if (change.type === "added"){
              vue.comments.push({content: change.doc.data().content, id: change.doc.id, uid: change.doc.data().uid, username: change.doc.data().username, date: change.doc.data().created});
            }
            vue.scrollBottom();
          });
          vue.topDate = vue.comments[0].date;
        });
      }
    });

  }
}
</script>
<style scoped>
.chat-display{
  /* height: 50vh; */
  /* overflow: scroll; */
}
.list-group-item {
  text-align: left;
}
</style>
